module.exports = __webpack_public_path__ + "img/login-logo-easyloon.fff6977b.png";